import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SearchService} from '../search/search.service';

@Component({
  selector: 'app-layout-logged-in',
  templateUrl: './layout-logged-in.component.html',
  styleUrls: ['./layout-logged-in.component.css']
})
export class LayoutLoggedInComponent implements OnInit {

  constructor(protected router: Router, protected searchService: SearchService) { }

  ngOnInit() {
  }
    public search(event) {
        const inputField = <HTMLInputElement>event.target[0];
        const searchTerm = inputField.value;
        inputField.value = '';
        this.router.navigate(['/search', {query: searchTerm}]);
        this.searchService.setSearchTerm(searchTerm);
    }
}



// WEBPACK FOOTER //
// ./src/app/layout-logged-in/layout-logged-in.component.ts